import React, { useEffect } from 'react';
import Loading from './atoms/Loading';
import { login } from '../services'
//import { Loader } from '../../atoms/loader';
import { useDispatch, useSelector } from 'react-redux';
import { fetchConfig } from '../store/config/actions';
import { setUser } from '../store/user/actions';
import { getConfigLoading } from '../store/config/selectors'
import { me } from '../services/dummy-data'

export const UserAuth = (props) => {
  const dispatch = useDispatch();
  const loading = useSelector(getConfigLoading);
  const fetch = async () =>{
    const userInfo = await login({
        email:"panda@gmail.com",
        password:"123456789"
    })
    dispatch(fetchConfig());
    dispatch(setUser({...me, ...userInfo.data}));
  }
  useEffect(() => {        
    fetch()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  if (loading) {
    return <Loading />
  }
  return <>{props.children}</>;
};

